import { ILMapLayer } from '../LMap';
export class BikeHikeHillshadingLayer implements ILMapLayer {
    public url: string = 'https://tiles.wmflabs.org/hillshading/{z}/{x}/{y}.png';
    public attribution: string = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
}
